import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { TitleCaseH2, TitleCaseH3, TitleCaseP, TitleCaseSpan } from './TitleCase';

const approaches = [
  {
    tag: 'Direct Access',
    title: 'Curated Individual Deals',
    description: 'For hands-on investors who want to select specific, high-growth opportunities.',
    imageUrl: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1260&q=80',
    link: '/investments?filter=direct',
  },
  {
    tag: 'Managed Funds',
    title: 'Diversified Thematic Portfolios',
    description: 'For investors seeking broad exposure to market trends through expertly managed funds.',
    imageUrl: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    link: '/investments?filter=funds',
  },
  {
    tag: 'Real Estate',
    title: 'Tangible Asset Investments',
    description: 'For those who want to own a piece of high-value property and earn rental income.',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    link: '/investments?filter=real-estate',
  },
];

const InvestmentApproaches = () => {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <TitleCaseH2 className="text-3xl md:text-4xl font-bold text-[hsl(var(--navy))] mb-4">
            Our Investment Approaches
          </TitleCaseH2>
          <TitleCaseP className="text-lg text-slate-600 max-w-3xl mx-auto">
            Choose The Investment Strategy That Aligns With Your Financial Goals And Risk Tolerance.
          </TitleCaseP>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {approaches.map((approach, index) => (
            <Link
              key={index}
              to={approach.link}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 block h-[400px]"
            >
              <div className="absolute inset-0 z-0">
                <img src={approach.imageUrl} alt={approach.title} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              </div>
              <div className="relative z-10 flex flex-col justify-end h-full p-6 text-white">
                <div>
                  <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider text-white bg-[hsl(var(--bronze-gold))] rounded-full mb-3">
                    <TitleCaseSpan>{approach.tag}</TitleCaseSpan>
                  </span>
                  <TitleCaseH3 className="text-2xl font-bold text-white mb-2">
                    {approach.title}
                  </TitleCaseH3>
                  <TitleCaseP className="text-white/90 mb-4">
                    {approach.description}
                  </TitleCaseP>
                  <div className="flex items-center text-sm font-medium text-white group-hover:text-[hsl(var(--bronze-gold))] transition-colors mt-4">
                    <TitleCaseSpan>Learn More</TitleCaseSpan>
                    <ArrowUpRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InvestmentApproaches;
